import {
  ModBreadcrumbLink,
  ModBreadcrumbs
} from '@moderneinc/design-system-components';
import type { FunctionComponent, JSX } from 'react';
import React from 'react';

import { ModerneMarkdown } from '../../utilities/markdown/markdown.component';

type BreadcrumbLink = {
  label: string;
  href?: string;
};

export type Breadcrumb = BreadcrumbLink | JSX.Element;

/**
 * Typeguard to decide whether a given object is a BreadcrumbLink.
 */
function isBreadCrumbLink(link: Breadcrumb): link is BreadcrumbLink {
  return (link as BreadcrumbLink).label !== undefined;
}

export const BreadcrumbsComponent: FunctionComponent<{
  links: Breadcrumb[];
}> = ({ links }) => {
  const defaultBreadcrumbs: Breadcrumb[] = [];
  const breadcrumbs = [...defaultBreadcrumbs, ...links];
  const lastIndex = breadcrumbs.length - 1;

  return breadcrumbs.length > 1 ? (
    <ModBreadcrumbs>
      {breadcrumbs.map((breadcrumb, index) => {
        const isCurrent = index === lastIndex;
        return isBreadCrumbLink(breadcrumb) ? (
          <ModBreadcrumbLink
            key={index}
            href={breadcrumb.href}
            current={isCurrent || !breadcrumb.href}
          >
            <ModerneMarkdown>{breadcrumb.label}</ModerneMarkdown>
          </ModBreadcrumbLink>
        ) : (
          <React.Fragment key={index}>{breadcrumb}</React.Fragment>
        );
      })}
    </ModBreadcrumbs>
  ) : null;
};
